/*
 * @fileOverView Form component definition
 */

import Vue from 'vue';
import Form from 'components/foundation/forms/form/form.mixin';
import Analytics from 'mixins/analytics.mixin';

/**
 * [Form Vue]
 * @type {class}
 */
Vue.component('form-scribe-vue', {
  mixins: [
    Analytics,
    Form
  ],

  methods: {
    initAnalytics() {
      this.setFormAnalyticsData({
        "formType": "Form - Scribe",
        "formName": window.mjffPageData ? window.mjffPageData.pageName : null
      });
      this.pushFormViewedEvent();
      this.$nextTick(() => {
        this.attachFormStartedEvent(this.$el.querySelector('form'), this.pushFormStartedEvent);
      });
    },

    validatorHighlight(element, errorClass, validClass) {
      $(element).parent().addClass('field_error');
    },

    validatorUnhighlight(element, errorClass, validClass) {
      $(element).parent().removeClass('field_error');
    },

    submit(form) {
      this.populateHiddenFormFields(form);

      const $form = $(form);
      const formObject = $form.serializeArray().reduce(function(m,o){ m[o.name] = o.value; return m;}, {});
      const data = JSON.stringify(formObject);

      $form.find('input[type="submit"]').val('Please wait...');

      $.ajaxSetup({
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        url: 'https://nkcj5mfz93.execute-api.us-east-2.amazonaws.com/prod/'
      });
      $.ajax({data: data}).always(response => {
        this.pushFormSubmissionSucceededEvent();

        window.location.href = window.location.href + '?s=true';
      });
    }
  }
})
